export default "__VITE_ASSET__DnhphAWg__"